import Vue from 'vue';

export default [
    {
        pathId: 'us',
        component: 'users',
        title: 'Users',
        icon: 'fa-users',
        size: 'sm', //sm, md, lg, xl
        reload: true,
        // loading: true
    }, {
        pathId: 'uq',
        component: 'user-search',
        title: 'Search Users',
        icon: 'fa-search',
        size: 'sm',
        props: ['query'],
        loading: true
    }, {
        pathId: 'u',
        component: 'user',
        title: 'User',
        icon: 'fa-user',
        size: 'md',
        props: ['userId'],
        loading: true
    }, {
        pathId: 'ud',
        component: 'user-details',
        title: 'Details',
        icon: 'fa-id-card',
        size: 'md',
        props: ['userId'],
        loading: true
    }, {
        pathId: 'ue',
        component: 'user-edit',
        title: 'Edit User',
        icon: 'fa-pencil',
        size: 'lg',
        loading: true,
        props: ['userId']
    }, {
        pathId: 'um',
        component: 'user-merge',
        title: 'Merge User',
        icon: 'fa-merge',
        size: 'xl',
        loading: true,
        props: ['userId']
    }, {
        pathId: 'notifications',
        component: 'notifications',
        size: 'md'
    }, {
        pathId: 'activity',
        component: 'recent-activity',
        size: 'md'
    }, {
        pathId: 'user-tickets',
        component: 'user-ticket-list',
        title: 'Support Tickets',
        icon: 'fa-life-ring',
        size: 'sm',
        props: ['userId'],
        loading: true
    }, {
        pathId: 'uces',
        component: 'course-enrollments',
        title: 'Course Enrollments',
        icon: 'fa-chalkboard-teacher',
        size: 'md',
        loading: true,
        reload: true,
        props: ['userId']
    }, {
        pathId: 'ucee',
        component: 'edit-enrollment',
        title: 'Edit Enrollment',
        icon: 'fa-pencil',
        size: 'lg',
        loading: true,
        props: ['userId', 'enrollId']
    }, {
        pathId: 'ucece',
        component: 'edit-classic-enrollment',
        title: 'Edit Classic Enrollment',
        icon: 'fa-pencil',
        size: 'lg',
        loading: true,
        props: ['userId', 'enrollId']
    },  {
        pathId: 'ucecn',
        component: 'new-classic-enrollment',
        title: 'New Classic Enrollment',
        icon: 'fa-plus',
        size: 'lg',
        loading: true,
        props: ['userId']
    }, {
        pathId: 'ucen',
        component: 'new-enrollment',
        title: 'New Enrollment',
        icon: 'fa-plus',
        size: 'lg',
        loading: true,
        props: ['userId']
    }, {
        pathId: 'uppl',
        component: 'user-payment-plans',
        title: 'Payment Plans',
        icon: 'fa-money-check-alt',
        size: 'sm',
        props: ['userId'],
    }, {
        pathId: 'user-conferences',
        component: 'user-conference-list',
        size: 'sm'
    }, {
        pathId: 'user-transactions',
        component: 'user-transaction-list',
        size: 'sm'
    }, {
        pathId: 'user-documents',
        component: 'user-documents',
        size: 'sm'
    }, {
        pathId: 'un',
        component: 'user-notes',
        size: 'md'
    }, {
        pathId: 'user-notifications',
        component: 'user-notifications',
        size: 'sm'
    },{
        pathId: 'reflection',
        component: 'user-reflection',
        size: 'md'
    }, {
        pathId: 'cart',
        component: 'user-shopping-cart-list',
        size: 'sm'
    }, {
        pathId: 'user-invoice-list',
        component: 'user-invoice-list',
        size: 'sm'
    }, {
        pathId: 'uat',
        component: 'user-activity',
        size: 'lg',
        props: ['userId'],
        loading: true
    }, {
        pathId: 'uar',
        component: 'user-account-requests',
        title: 'TPO Activity/Requests',
        icon: 'fa-message-check',
        size: 'md',
        props: ['userId'],
        loading: true
    }, {
        pathId: 'user-study-log',
        component: 'user-study-log',
        title: 'Study Log',
        icon: 'fa-book',
        size: 'full',
        props: ['userId'],
    }
];

Vue.component('users', () => import('@/cards/users/Users'));
Vue.component('user-search', () => import('@/cards/users/UserSearch'));
Vue.component('user', () => import('@/cards/users/User'));
Vue.component('user-details', () => import('@/cards/users/UserDetails'));
Vue.component('user-edit', () => import('@/cards/users/UserEdit'));
Vue.component('user-merge', () => import('@/cards/users/Merge'));
Vue.component('user-ticket-list', () => import('@/cards/users/UserTicketList'));
Vue.component('course-enrollments', () => import('@/cards/users/CourseEnrollments'));
Vue.component('edit-enrollment', () => import('@/cards/users/EditEnrollment'));
Vue.component('edit-classic-enrollment', () => import('@/cards/users/EditClassicEnrollment'));
Vue.component('new-classic-enrollment', () => import('@/cards/users/NewClassicEnrollment'));
Vue.component('new-enrollment', () => import('@/cards/users/NewEnrollment'));
Vue.component('user-payment-plans', () => import('@/cards/users/UserPaymentPlansList'));
Vue.component('user-conference-list', () => import('@/cards/users/UserConferenceList'));
Vue.component('user-transaction-list', () => import('@/cards/users/UserTransactionList'));
Vue.component('user-documents', () => import('@/cards/users/UserDocuments'));
Vue.component('user-notes', () => import('@/cards/users/UserNotes'));
Vue.component('user-notifications', () => import('@/cards/users/UserNotifications'));
Vue.component('user-activity', () => import('@/cards/users/UserActivity'));
Vue.component('user-reflection', () => import('@/cards/users/UserReflection'));
Vue.component('user-shopping-cart-list', () => import('@/cards/users/UserShoppingCartList'));
Vue.component('user-invoice-list', () => import('@/cards/users/UserInvoiceList'));
Vue.component('user-activity', () => import('@/cards/users/Activity'));
Vue.component('user-account-requests', () => import('@/cards/users/UserAccountRequests'));
Vue.component('user-study-log', () => import('@/cards/users/UserStudyLog'));
